import { useBoolean } from 'codekit';
import { motion } from 'framer-motion';

import * as F from 'models/Faq';
import * as Icons from 'icons';
import { faqVariants } from 'constants/home';

import { FaqQuestionContainer } from './styles';

interface ComponentProps {
	question: F.FaqQuestion;
}

const FaqQuestionContainerMotion = motion(FaqQuestionContainer);

function FaqQuestion(props: ComponentProps) {
	// Boolean hooks
	const isActive = useBoolean();

	// Functions
	function active(state: boolean) {
		return state ? 'active' : '';
	}

	return (
		<FaqQuestionContainerMotion
			className={`question ${active(isActive.value)}`}
			variants={faqVariants.item}
		>
			<div className="question-content" onClick={isActive.toggle}>
				<span>{props.question.question}</span>

				<i>
					<Icons.FiChevronDown />
				</i>
			</div>

			<div className="answer">
				<p>{props.question.answer}</p>
			</div>
		</FaqQuestionContainerMotion>
	);
}

export default FaqQuestion;
